import React, { useState, useEffect } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import logoHaraz from "../assets/Haraz_Logo.png";
import logoZagoo from "../assets/Zagoo_Logo.png";
import logoAlima from "../assets/Alima_Logo.png";
import backgroundImage from "../assets/bgImage.png";
import bgImage from "../assets/bgImageMonitorSize.png";
import sideImage from "../assets/chedar.jpg";

const ForgotPasswordPage = () => {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otpCode, setOtpCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!countdown) return;
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) clearInterval(timer);
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  const isValidPassword = (password) =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/.test(password);

  const sendOtp = async () => {
    try {
      await axios.post("/otp/request-otp-reset", `"${mobile}"`, {
        headers: { "Content-Type": "application/json" },
      });
      //   Swal.fire("موفق", "کد تأیید ارسال شد.", "success");
      setStep(2);
      setCountdown(120);
    } catch (error) {
      Swal.fire("خطا", "خطا در ارسال کد.", "error");
    }
  };

  const verifyOtpCode = async () => {
    try {
      const { data } = await axios.post("/otp/verify", {
        mobile,
        code: otpCode,
      });
      if (data === true) {
        setStep(3);
      } else {
        Swal.fire("خطا", "کد واردشده نادرست است.", "error");
      }
    } catch (error) {
      Swal.fire("خطا", error.response?.data || "کد اشتباه است.", "error");
    }
  };

  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      Swal.fire("عدم تطابق", "رمز عبور و تکرار آن برابر نیستند.", "warning");
      return;
    }

    if (!isValidPassword(newPassword)) {
      Swal.fire({
        icon: "error",
        title: "رمز عبور ضعیف",
        html: "رمز باید حداقل <b>۶ کاراکتر</b> و شامل <b>حروف بزرگ</b>، <b>حروف کوچک</b> و <b>عدد</b> باشد.",
      });
      return;
    }

    try {
      await axios.post("/otp/reset-password", {
        mobile,
        code: otpCode,
        newPassword,
      });
      Swal.fire("انجام شد", "رمز عبور با موفقیت تغییر یافت.", "success");
      navigate("/login");
    } catch (error) {
      Swal.fire(
        "خطا",
        error.response?.data || "تغییر رمز عبور با خطا مواجه شد.",
        "error"
      );
    }
  };

  const renderStepContent = () => {
    switch (step) {
      case 1:
        return (
          <>
            <input
              type="tel"
              placeholder="شماره موبایل"
              className="w-full p-3 rounded-lg border bg-yellow-100 text-right"
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
            />
            <div className="flex gap-3 mt-2">
              <button
                type="button"
                className="w-full bg-blue-700 text-white py-2 rounded-lg font-bold text-sm"
                onClick={sendOtp}
                disabled={mobile.length !== 11}
              >
                ارسال کد تأیید
              </button>
              <button
                type="button"
                className="w-full border border-blue-700 text-blue-700 py-2 rounded-lg font-bold text-sm"
                onClick={() => navigate(-1)} // یا هر صفحه‌ای که می‌خوای برگرده
              >
                بازگشت
              </button>
            </div>
          </>
        );

      case 2:
        return (
          <>
            <input
              type="text"
              placeholder="کد تأیید"
              className="w-full p-3 rounded-lg border bg-yellow-50 text-center tracking-widest text-sm"
              value={otpCode}
              onChange={(e) => setOtpCode(e.target.value)}
              maxLength={4}
            />
            <div className="flex justify-between gap-3 mt-2">
              <button
                type="button"
                className={`w-full ${countdown === 0
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-gray-400 cursor-not-allowed"
                  } text-white py-2 rounded-lg font-bold text-sm`}
                onClick={sendOtp}
                disabled={countdown > 0}
              >
                {countdown > 0
                  ? `ارسال مجدد تا ${countdown} ثانیه`
                  : "ارسال مجدد کد"}
              </button>
              <button
                type="button"
                className="w-full border border-blue-700 text-blue-700 py-2 rounded-lg font-bold text-sm"
                onClick={() => {
                  setStep(1);
                  setOtpCode("");
                  setCountdown(0);
                }}
              >
                بازگشت
              </button>
            </div>
            <button
              type="button"
              className={`w-full ${otpCode.length >= 4
                ? "bg-blue-700 hover:bg-blue-800"
                : "bg-gray-400 cursor-not-allowed"
                } text-white py-2 rounded-lg font-bold text-sm mt-2`}
              onClick={verifyOtpCode}
              disabled={otpCode.length < 4}
            >
              تأیید کد
            </button>
          </>
        );

      case 3:
        return (
          <>
            <div className="relative">
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="رمز عبور جدید"
                className="w-full p-3 rounded-lg border bg-yellow-100"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span
                className="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer text-gray-600"
                onClick={() => setShowNewPassword((prev) => !prev)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="تکرار رمز عبور جدید"
                className="w-full p-3 rounded-lg border bg-yellow-100"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span
                className="absolute top-1/2 left-3 transform -translate-y-1/2 cursor-pointer text-gray-600"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <button
              type="button"
              className="w-full bg-green-700 text-white py-2 rounded-lg font-bold text-sm mt-2"
              onClick={handleResetPassword}
            >
              ثبت رمز جدید
            </button>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="relative min-h-screen w-full flex items-stretch">
      <img
        src={backgroundImage}
        alt="bg mobile"
        className="absolute inset-0 w-full h-full object-cover z-0 block md:hidden"
      />
      <img
        src={bgImage}
        alt="bg desktop"
        className="absolute inset-0 w-full h-full object-cover z-0 hidden md:block"
      />
      <div className="relative z-10 flex flex-col md:flex-row w-full">
        <div className="hidden md:flex items-center justify-center w-1/2 p-4">
          <div
            className="w-full h-full rounded-2xl overflow-hidden bg-cover bg-center"
            style={{ backgroundImage: `url(${sideImage})` }}
          />
        </div>
        <div className="w-full md:w-1/2 flex items-center justify-center p-4 min-h-screen">
          <div className="bg-white/90 backdrop-blur-md p-6 rounded-2xl shadow-lg max-w-md w-full text-center m-4">
            <div className="flex justify-center gap-4 mb-6">
              <img src={logoZagoo} alt="Zagoo" className="h-14 object-contain" />
              <img src={logoAlima} alt="Alima" className="h-14 object-contain" />
              <img src={logoHaraz} alt="Haraz" className="h-14 object-contain" />
            </div>
            <h2 className="text-xl font-bold text-blue-900 mb-4">
              بازیابی رمز عبور
            </h2>
            <form className="space-y-3 text-right" dir="rtl">
              {renderStepContent()}
            </form>
            <p className="mt-4 text-blue-900 font-bold text-sm">
              لبنیات دوشه آمل
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
